var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.17,
    height: 31.17,
    viewBox: "0 0 31.17 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "audio",
    transform: "translate(-3952.859 -1912.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M3984.029,1922.148v17.39a4.421,4.421,0,0,1-4.42,4.42h-22.33a4.422,4.422,0,0,1-4.42-4.42v-22.33a4.422,4.422,0,0,1,4.42-4.42h17.39Z",
    fill: "#facd30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M3974.669,1917.728v-4.94l9.36,9.36h-4.94A4.421,4.421,0,0,1,3974.669,1917.728Z",
    fill: "#ffe971"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M3967.025,1933.869h0c0-.046,0-.091,0-.137q0-4.836,0-9.671c0-.035,0-.071,0-.107a.485.485,0,0,0-.734-.38q-2.329,1.371-4.656,2.745c-.149.088-.3.171-.445.265a.6.6,0,0,1-.343.1q-.7-.009-1.407,0a1.477,1.477,0,0,0-1.473,1.466c-.007.551,0,1.1,0,1.652a.1.1,0,0,1,.012.055l-.012-.055c0,.265,0,.53,0,.8a1.463,1.463,0,0,0,1.474,1.474c.372,0,.745.015,1.117,0a1.176,1.176,0,0,1,.83.227,1.828,1.828,0,0,0,.252.143h0l3.295,1.947c.446.264.892.529,1.34.789a.488.488,0,0,0,.752-.382C3967.035,1934.481,3967.026,1934.175,3967.025,1933.869Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M3976.656,1929.231a10.61,10.61,0,0,1-3.053,7.516.7.7,0,1,1-1.008-.976,9.085,9.085,0,0,0,.648-12.067c-.2-.253-.418-.486-.635-.721a.705.705,0,1,1,1.007-.981,10.412,10.412,0,0,1,2.65,4.579,9.98,9.98,0,0,1,.273,1.293C3976.608,1928.37,3976.627,1928.874,3976.656,1929.231Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M3972.747,1929.165a6.791,6.791,0,0,1-1.872,4.778.716.716,0,0,1-.783.234.7.7,0,0,1-.259-1.184,4.938,4.938,0,0,0,1.213-1.969,5.07,5.07,0,0,0-1.184-5.248.736.736,0,0,1-.1-1.006.7.7,0,0,1,1.068-.022,6.347,6.347,0,0,1,1.73,3.141C3972.665,1928.377,3972.706,1928.88,3972.747,1929.165Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.a9d92b4e1920e11bcfecfca12a823a1f.svg";
export { ForwardRef as ReactComponent };